import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-help-conditional-dimensions',
  templateUrl: './help-conditional-dimensions.component.html',
  styleUrls: ['./help-conditional-dimensions.component.scss']
})
export class HelpConditionalDimensionsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
